export default "__VITE_ASSET__BndvVGqb__"